import { InjectionToken } from '@angular/core';
import { SearchStrategy } from '../models/search-strategy.model';

/**
 * Multi-provider token. All scoring strategies (Exact, Fuzzy, NGram,
 * Keyword, Semantic, Intent, Token, CompoundSplit) are registered through
 * this token so new strategies can be added without modifying the engine.
 */
export const SEARCH_STRATEGIES = new InjectionToken<readonly SearchStrategy[]>(
  'SEARCH_STRATEGIES'
);
